import * as React from 'react';
import { AppBar, Box, Toolbar } from '@mui/material';

import { navy50 } from '../../../constants/colors';
import { spHeaderHeight } from '../../../constants/location';
import logoImage from '../../assets/logo.png';

type Props = {
  pcIsNone?: boolean;
};

const Header = React.forwardRef((props: Props, _ref): React.ReactElement => {
  const { pcIsNone } = props;

  return (
    <AppBar
      sx={{
        backgroundColor: navy50,
        boxShadow: 'none',
        '@media screen and (max-width: 600px)': {
          height: spHeaderHeight,
        },
        '@media screen and (min-width: 960px)': {
          display: pcIsNone ? 'none' : 'auto',
        },
      }}
    >
      <Toolbar
        sx={{
          '@media screen and (max-width: 600px)': {
            minHeight: spHeaderHeight,
          },
        }}
      >
        <Box
          component="img"
          src={logoImage}
          sx={{
            width: 180,
          }}
        />
      </Toolbar>
    </AppBar>
  );
});

Header.displayName = 'Header';
export default Header;
